var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('div',[_c('h1',{attrs:{"align":"center","justify":"center"}},[_vm._v("Search Results")]),_c('ul',_vm._l((_vm.movies),function(movie){return _c('li',{key:movie.id},[_c('strong',[_vm._v(_vm._s(movie.title))]),_c('p',[_vm._v(_vm._s(movie.overview))])])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }